// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_wrapper__YyFp5"};